/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSubscriptionReport } from '../fn/subscriptions-report/create-subscription-report';
import { CreateSubscriptionReport$Params } from '../fn/subscriptions-report/create-subscription-report';
import { deleteSubscriptionReport } from '../fn/subscriptions-report/delete-subscription-report';
import { DeleteSubscriptionReport$Params } from '../fn/subscriptions-report/delete-subscription-report';
import { exportReportingImmediatelyClipro } from '../fn/subscriptions-report/export-reporting-immediately-clipro';
import { ExportReportingImmediatelyClipro$Params } from '../fn/subscriptions-report/export-reporting-immediately-clipro';
import { exportReportingImmediatelyGnvert } from '../fn/subscriptions-report/export-reporting-immediately-gnvert';
import { ExportReportingImmediatelyGnvert$Params } from '../fn/subscriptions-report/export-reporting-immediately-gnvert';
import { exportReportingImmediatelyPgcsv } from '../fn/subscriptions-report/export-reporting-immediately-pgcsv';
import { ExportReportingImmediatelyPgcsv$Params } from '../fn/subscriptions-report/export-reporting-immediately-pgcsv';
import { exportReportingImmediatelyPgxls } from '../fn/subscriptions-report/export-reporting-immediately-pgxls';
import { ExportReportingImmediatelyPgxls$Params } from '../fn/subscriptions-report/export-reporting-immediately-pgxls';
import { exportSubscriptionContacts } from '../fn/subscriptions-report/export-subscription-contacts';
import { ExportSubscriptionContacts$Params } from '../fn/subscriptions-report/export-subscription-contacts';
import { getSubscriptionReport } from '../fn/subscriptions-report/get-subscription-report';
import { GetSubscriptionReport$Params } from '../fn/subscriptions-report/get-subscription-report';
import { getSubscriptionReports } from '../fn/subscriptions-report/get-subscription-reports';
import { GetSubscriptionReports$Params } from '../fn/subscriptions-report/get-subscription-reports';
import { SubscriptionReport } from '../models/subscription-report';
import { SubscriptionReportPagedList } from '../models/subscription-report-paged-list';
import { triggerSubscriptionReports } from '../fn/subscriptions-report/trigger-subscription-reports';
import { TriggerSubscriptionReports$Params } from '../fn/subscriptions-report/trigger-subscription-reports';
import { updateSubscriptionReport } from '../fn/subscriptions-report/update-subscription-report';
import { UpdateSubscriptionReport$Params } from '../fn/subscriptions-report/update-subscription-report';


/**
 * All about the custom subscriptions reports
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionsReportService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportSubscriptionContacts()` */
  static readonly ExportSubscriptionContactsPath = '/custom/subscriptions/contacts/export';

  /**
   * Export the contacts and their messages choices to this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportSubscriptionContacts$Response(params?: ExportSubscriptionContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the contacts and their messages choices to this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportSubscriptionContacts(params?: ExportSubscriptionContacts$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getSubscriptionReports()` */
  static readonly GetSubscriptionReportsPath = '/custom/subscriptions/{uid}/reports';

  /**
   * Get a list of subscription reports, with pagination.
   *
   * Get list of subscription reports, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionReports$Response(params: GetSubscriptionReports$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionReportPagedList>> {
    return getSubscriptionReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a list of subscription reports, with pagination.
   *
   * Get list of subscription reports, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionReports(params: GetSubscriptionReports$Params, context?: HttpContext): Observable<SubscriptionReportPagedList> {
    return this.getSubscriptionReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionReportPagedList>): SubscriptionReportPagedList => r.body)
    );
  }

  /** Path part for operation `createSubscriptionReport()` */
  static readonly CreateSubscriptionReportPath = '/custom/subscriptions/{uid}/reports';

  /**
   * Create a subscription report entry.
   *
   * create a subscription report entry
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscriptionReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionReport$Response(params: CreateSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubscriptionReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a subscription report entry.
   *
   * create a subscription report entry
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscriptionReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionReport(params: CreateSubscriptionReport$Params, context?: HttpContext): Observable<void> {
    return this.createSubscriptionReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionReport()` */
  static readonly GetSubscriptionReportPath = '/custom/subscriptions/{uid}/reports/{reportUid}';

  /**
   * Get a subscription report entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionReport$Response(params: GetSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionReport>> {
    return getSubscriptionReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription report entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionReport(params: GetSubscriptionReport$Params, context?: HttpContext): Observable<SubscriptionReport> {
    return this.getSubscriptionReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionReport>): SubscriptionReport => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionReport()` */
  static readonly UpdateSubscriptionReportPath = '/custom/subscriptions/{uid}/reports/{reportUid}';

  /**
   * Update a subscription report entry.
   *
   * Update a subscription report entry
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionReport$Response(params: UpdateSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription report entry.
   *
   * Update a subscription report entry
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionReport(params: UpdateSubscriptionReport$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubscriptionReport()` */
  static readonly DeleteSubscriptionReportPath = '/custom/subscriptions/{uid}/reports/{reportUid}';

  /**
   * Delete a subscription report entry.
   *
   * Delete a subscription report entry
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubscriptionReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionReport$Response(params: DeleteSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubscriptionReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a subscription report entry.
   *
   * Delete a subscription report entry
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubscriptionReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionReport(params: DeleteSubscriptionReport$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubscriptionReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `triggerSubscriptionReports()` */
  static readonly TriggerSubscriptionReportsPath = '/custom/subscriptions/{uid}/reports/{reportUid}/trigger';

  /**
   * Trigger this report to be sent immediately.
   *
   * Trigger this report to be sent immediately
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerSubscriptionReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerSubscriptionReports$Response(params: TriggerSubscriptionReports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return triggerSubscriptionReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Trigger this report to be sent immediately.
   *
   * Trigger this report to be sent immediately
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerSubscriptionReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerSubscriptionReports(params: TriggerSubscriptionReports$Params, context?: HttpContext): Observable<void> {
    return this.triggerSubscriptionReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportReportingImmediatelyClipro()` */
  static readonly ExportReportingImmediatelyCliproPath = '/custom/subscriptions/{uid}/reports/clipro';

  /**
   * Export the reports CLIPRO as a CSV File.
   *
   * Allows to export the reports CLIPRO as a CSV File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportingImmediatelyClipro()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyClipro$Response(params: ExportReportingImmediatelyClipro$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportReportingImmediatelyClipro(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the reports CLIPRO as a CSV File.
   *
   * Allows to export the reports CLIPRO as a CSV File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportReportingImmediatelyClipro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyClipro(params: ExportReportingImmediatelyClipro$Params, context?: HttpContext): Observable<Blob> {
    return this.exportReportingImmediatelyClipro$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportReportingImmediatelyPgcsv()` */
  static readonly ExportReportingImmediatelyPgcsvPath = '/custom/subscriptions/{uid}/reports/pgcsv';

  /**
   * Export the reports PGCSV as a CSV File.
   *
   * Allows to export the reports PGCSV as a CSV File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportingImmediatelyPgcsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyPgcsv$Response(params: ExportReportingImmediatelyPgcsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportReportingImmediatelyPgcsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the reports PGCSV as a CSV File.
   *
   * Allows to export the reports PGCSV as a CSV File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportReportingImmediatelyPgcsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyPgcsv(params: ExportReportingImmediatelyPgcsv$Params, context?: HttpContext): Observable<Blob> {
    return this.exportReportingImmediatelyPgcsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportReportingImmediatelyPgxls()` */
  static readonly ExportReportingImmediatelyPgxlsPath = '/custom/subscriptions/{uid}/reports/pgxls';

  /**
   * Export the reports PGXLS as a XLS File.
   *
   * Allows to export the reports PGXLS as a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportingImmediatelyPgxls()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyPgxls$Response(params: ExportReportingImmediatelyPgxls$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportReportingImmediatelyPgxls(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the reports PGXLS as a XLS File.
   *
   * Allows to export the reports PGXLS as a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportReportingImmediatelyPgxls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyPgxls(params: ExportReportingImmediatelyPgxls$Params, context?: HttpContext): Observable<Blob> {
    return this.exportReportingImmediatelyPgxls$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportReportingImmediatelyGnvert()` */
  static readonly ExportReportingImmediatelyGnvertPath = '/custom/subscriptions/{uid}/reports/gnvert';

  /**
   * Export the reports for a subscription in XLSX format.
   *
   * Allows to export all the reports as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportReportingImmediatelyGnvert()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyGnvert$Response(params: ExportReportingImmediatelyGnvert$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportReportingImmediatelyGnvert(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the reports for a subscription in XLSX format.
   *
   * Allows to export all the reports as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportReportingImmediatelyGnvert$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportReportingImmediatelyGnvert(params: ExportReportingImmediatelyGnvert$Params, context?: HttpContext): Observable<Blob> {
    return this.exportReportingImmediatelyGnvert$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
